import React, { useState } from 'react';
import classnames from 'classnames';

import story_1 from '../../../../assets/img/story1.png';
import story_2 from '../../../../assets/img/story2.png';
import story_3 from '../../../../assets/img/story3.png';
import { Button } from '../../../shared/components/button/button.component';
import 'bulma/css/bulma.css';
import styles from './card.module.scss';

export const Card = (props) => {
  const { storyId, name, title, paragraph, comic } = props;
  const [readMore, setReadMore] = useState(false);
  let storyImg;

  switch (storyId) {
    case 1: 
      storyImg = story_1;
      break;
    case 2: 
      storyImg = story_2;
      break;
    case 3: 
      storyImg = story_3;
      break;
    default: 
      storyImg = story_1;
      break;
  }

  return (
    <div className={classnames( styles.card_container)}>
      <div className="card-image">
        <figure className="image is-4by4">
          <img className={styles.cardImg} src={storyImg} alt="storyImage" />
        </figure>
      </div>

      <div className="content">
        <p className={styles.name}>{name}</p>
        <div className={styles.titlebox}>
          <span className={styles.title}>{title}</span>
          {readMore && <div className={styles.par}>{paragraph}</div>}
          <button 
            className={styles.readMore}
            onClick={() => setReadMore(!readMore)}
          >
            {readMore ? 'Read less' : 'Read more'}
          </button>
        </div>
        <Button storyId={storyId.toString()} />
        <a href={comic} download="" className={styles.download}>Download PDF</a>
      </div>
    </div>
  );
};